require('../../modules/es6.object.create');
var $Object = require('../../modules/_core').Object;
module.exports = function create(P, D){
  return $Object.create(P, D);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/.2.4.1@core-js/library/fn/object/create.js
 ** module id = 476
 ** module chunks = 0 1
 **/